import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Position, PositionFormPayload } from '../../types/position'

export const positionService = {
  async list(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
  }) {
    const { data } = await apiClient.get<ApiPaginatedResponse<Position> | ApiSuccessResponse<Position[]>>(
      '/positions',
      { params },
    )
    return data
  },

  async create(payload: PositionFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Position>>('/positions', payload)
    return data
  },

  async update(id: string, payload: PositionFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Position>>(`/positions/${id}`, payload)
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/positions/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Position>>(`/positions/${id}/restore`)
    return data
  },
}
